import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import {IUserDetails} from "@irb/app.model";
import {AppService} from "@irb/app.service";
import {map} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class IrbModelsService {
  httpOptions = {
    headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache',
        'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
    })
  };

    isUseSecurityService = false;
    securityServiceUrlPrefix = '/irebalone/security';

  constructor(private _http: HttpClient, private as: AppService) {
      this.isUseSecurityService = this.as.getItem('IRB_APP_CONFIG')?.featureFlags?.ENABLE_SECURITY_APIS || false;
      if (this.isUseSecurityService)
          this.securityServiceUrlPrefix = '/irebal-security';
      this.getUserDetails();
  }

  getUserDetails(): void {
        this.as.getUserDetails().subscribe((userDetails: IUserDetails) => {
            if (userDetails) {
                this.isUseSecurityService = userDetails.featureFlags && userDetails.featureFlags.ENABLE_SECURITY_APIS;
            }
        });
  }

  getSecuritiesCustomCategories(): Observable<Object> {
    let url = `${this.securityServiceUrlPrefix}/get-custom-categories`;
    return this._http.get(url, this.httpOptions).pipe(map(res => this.defineResponse(res)));
  }
  getGlobalSettingDetails(): Observable<Object> {
    return this._http.get("/irebalone/accounts/get-global-setting-details", this.httpOptions);
  }

  defineResponse(res: any) {
    return  res && res.data && res.data.irebalResponse ? res.data.irebalResponse : res;
  }
}
